import { useState } from "react";
import { Link } from "wouter";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { listWorkspaces } from "@/lib/admin";
import { useAdminQuery } from "@/hooks/useAdminQuery";

export default function AdminCompanies() {
  const [search, setSearch] = useState("");

  const {
    data: workspaces,
    loading,
    error,
  } = useAdminQuery(() => listWorkspaces(search || undefined).then((r) => r.workspaces), [search], {
    debounceMs: 300,
  });

  const rows = workspaces ?? [];

  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-heading font-extrabold">Companies</h1>

      <Input
        placeholder="Search by company name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="sm:max-w-xs"
      />

      {error && <p className="text-sm text-destructive">{error}</p>}

      <div className="rounded-xl border border-border bg-card shadow-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Sector</TableHead>
              <TableHead>Users</TableHead>
              <TableHead>Assets</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} className="py-8 text-center text-muted-foreground">
                  Loading...
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="py-8 text-center text-muted-foreground">
                  No companies found.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((ws) => (
                <TableRow key={ws.id} className="cursor-pointer">
                  <TableCell>
                    <Link href={`/admin/companies/${ws.id}`} className="font-medium text-primary hover:underline">
                      {ws.name}
                    </Link>
                  </TableCell>
                  <TableCell className="capitalize">{ws.sector}</TableCell>
                  <TableCell>{ws.userCount}</TableCell>
                  <TableCell>{ws.assetCount}</TableCell>
                  <TableCell>
                    <span className={ws.active ? "text-emerald-600" : "text-muted-foreground"}>
                      {ws.active ? "Active" : "Disabled"}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
